import { useEffect, useState, useRef } from 'react';
import { Board } from '../../../components/Board';
import { NavButton } from '../../../components/NavButton';
import styles from './styles.module.scss';
import JSConfetti from 'js-confetti';
import { RisadaAleatoria } from './loadRisada';
import { ParabensAleatorio } from './loadParabens';
import $ from 'jquery';

export const Pergunta = ({ pergunta, tempo, finish, jogador, musica, adicionarPonto }) => {
    const [respondeu, setRespondeu] = useState<boolean>(false);
    const [corrijiu, setCorrijiu] = useState<boolean>(false);
    const [timeRespondido, setTime] = useState<number | undefined>(undefined);
    const [resultado, setResultado] = useState<'correct' | 'wrong' | 'timeout' | null>(null);
    const [marcado, setMarcado] = useState<number>(0);
    const confettiRef = useRef<JSConfetti | null>(null);
    const awardedRef = useRef<boolean>(false); // evita dar ponto múltiplo

    useEffect(() => {
        confettiRef.current = new JSConfetti();
    }, []);

    // progresso usado para checar timeout
    const progresso = ((timeRespondido ?? tempo) / 30) * 100;

    // timeout automático
    useEffect(() => {
        if ((tempo ?? 0) <= 0 && !respondeu) {
            // registra resposta por timeout e corrige imediatamente
            encerrar(0);
            corrijir(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tempo]);

    if (!pergunta) return <></>;

    const corrijir = (markedParam?: number) => {
        if (corrijiu) return; // evita correção múltipla
        setCorrijiu(true);

        const marked = typeof markedParam === 'number' ? markedParam : marcado;

        // revela alternativa correta (usa jQuery como no código original)
        try {
            $('#Alternativa' + pergunta.correct).addClass(styles.CORRETA);
        } catch (e) {
            /* ignore if jQuery não aplicar */
        }

        if (marked === pergunta.correct) {
            setResultado('correct');

            // só adiciona ponto uma vez por pergunta
            if (!awardedRef.current && jogador?.id) {
                adicionarPonto(jogador.id);
                awardedRef.current = true;
            }

            ParabensAleatorio();
        } else {
            setResultado(marked === 0 ? 'timeout' : 'wrong');

            confettiRef.current?.addConfetti({
                emojis: [' ', ' '],
                confettiNumber: 20,
                confettiRadius: 500
            });
            setTimeout(
                () =>
                    confettiRef.current?.addConfetti({
                        emojis: [' '],
                        confettiNumber: 20,
                        confettiRadius: 500
                    }),
                500
            );
            setTimeout(
                () =>
                    confettiRef.current?.addConfetti({
                        emojis: [' '],
                        confettiNumber: 20,
                        confettiRadius: 500
                    }),
                1500
            );

            RisadaAleatoria();
        }
    };

    const encerrar = (respondido: number) => {
        if (respondeu) return;
        try {
            musica?.pause();
        } catch (e) {
            /* noop */
        }
        setRespondeu(true);
        setMarcado(respondido);
        setTime(tempo);
    };

    const getProgressColor = (percent: number) => {
        const clamped = Math.max(0, Math.min(100, percent));
        const hue = (clamped / 100) * 120;
        return `hsl(${hue}, 100%, 50%)`;
    };

    return (
        <div className={styles.wrapper}>
            <Board wrapperClass={styles.board}>
                <div id='print-section' className={styles.content}>
                    {/* HEADER: avatar / name / timer */}
                    <div className={styles.header}>
                        <div className={styles.playerBox}>
                            <div className={styles.avatarWrap}>
                                <img
                                    className={styles.avatar}
                                    src={jogador?.image?.url}
                                    alt={jogador?.name || 'Jogador'}
                                />
                            </div>
                            <div className={styles.playerInfo}>
                                <div className={styles.playerName}>{jogador?.name ?? '—'}</div>
                               <div className={styles.timerNumber}>{timeRespondido ?? tempo}s</div>
                            </div>
                        </div>
                        <div className={styles.actionsRow}>
                        {respondeu && (
                            <button
                                onClick={() => {
                                    if (corrijiu) {
                                        finish();
                                        return;
                                    }
                                    // usa o marcado atual para corrigir (evita depender de setState async)
                                    corrijir(marcado);
                                }}
                                className={`${styles.continueButton} ${!respondeu ? styles.continueDisabled : ''}`}
                                disabled={!respondeu}
                                aria-disabled={!respondeu}
                            >
                                Continuar
                            </button>
                        )}
                    </div>

                    </div>

                    {/* progress */}
                    <div className={styles.progressBarWrapper} aria-hidden>
                        <div
                            className={`${styles.progressBar} ${
                                resultado === 'wrong' ? styles.progressWrong : ''
                            } ${resultado === 'correct' ? styles.progressCorrect : ''}`}
                            style={{
                                width: `${Math.max(0, Math.min(100, progresso))}%`,
                                backgroundColor: getProgressColor(progresso)
                            }}
                        />
                    </div>

                    {/* pergunta */}
                    <div className={styles.questionContainer}>
                        <p className={styles.questionText}>{pergunta.enunciado}</p>

                        {/* resolução — aparece com animação só quando respondeu */}
                        <div
                            className={`${styles.resolutionCard} ${
                                respondeu ? styles.resolutionShow : ''
                            } ${
                                resultado === 'correct'
                                    ? styles.resolutionCorrect
                                    : resultado === 'wrong'
                                    ? styles.resolutionWrong
                                    : ''
                            }`}
                            role='status'
                            aria-live='polite'
                        >
                            {corrijiu ? (
                                <>
                                    <div className={styles.resolutionText}>
                                        {resultado === 'correct' && <strong>Acertou! Bom trabalho.</strong>}
                                        {resultado === 'wrong' && (
                                            <strong>Quase lá — confira a resolução:</strong>
                                        )}
                                        {resultado === 'timeout' && (
                                            <strong>Tempo esgotado — veja a resolução:</strong>
                                        )}
                                        <div className={styles.resolutionDetail}>{pergunta.resolucao}</div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>

                    {/* respostas */}
                    <div className={styles.answersGrid}>
                        <button
                            id='Alternativa1'
                            onClick={() => encerrar(1)}
                            disabled={respondeu}
                            className={`${styles.answerButton} ${marcado == 1 ? styles.marcado : ''}`}
                            aria-label='Alternativa A'
                        >
                            <span className={styles.letter}>A</span>
                            <span className={styles.answerText}>{pergunta.a}</span>
                        </button>

                        <button
                            id='Alternativa2'
                            onClick={() => encerrar(2)}
                            disabled={respondeu}
                            className={`${styles.answerButton} ${marcado == 2 ? styles.marcado : ''}`}
                            aria-label='Alternativa B'
                        >
                            <span className={styles.letter}>B</span>
                            <span className={styles.answerText}>{pergunta.b}</span>
                        </button>

                        <button
                            id='Alternativa3'
                            onClick={() => encerrar(3)}
                            disabled={respondeu}
                            className={`${styles.answerButton} ${marcado == 3 ? styles.marcado : ''}`}
                            aria-label='Alternativa C'
                        >
                            <span className={styles.letter}>C</span>
                            <span className={styles.answerText}>{pergunta.c}</span>
                        </button>

                        <button
                            id='Alternativa4'
                            onClick={() => encerrar(4)}
                            disabled={respondeu}
                            className={`${styles.answerButton} ${marcado == 4 ? styles.marcado : ''}`}
                            aria-label='Alternativa D'
                        >
                            <span className={styles.letter}>D</span>
                            <span className={styles.answerText}>{pergunta.d}</span>
                        </button>

                        <button
                            id='Alternativa5'
                            onClick={() => encerrar(5)}
                            disabled={respondeu}
                            className={`${styles.answerButton} ${marcado == 5 ? styles.marcado : ''}`}
                            aria-label='Alternativa E'
                        >
                            <span className={styles.letter}>E</span>
                            <span className={styles.answerText}>{pergunta.e}</span>
                        </button>
                    </div>

                    {/* botão continuar */}
                    
                </div>
            </Board>
            <NavButton
                route='/manager'
                direction='left'
                style={{ left: '0.4vw', top: '2vw', zIndex: 20 }}
            />
        </div>
    );
};